import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import EmptyRow from '../../../components/Simple/EmptyRow';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCLabel from '../../../components/Simple/SMCLabel';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function ServerWizardBody({
    onCancel,
    onFinish,
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        name, setName,
        smsAddress, setSmsAddress,
        smpServerAddress, setSmpServerAddress,
        smpNatAddress, setSmpNatAddress
    } = wizardVars;

    return (
        <>
            <SMCModalBody lineHeight="22px" labelWidth={300}>
                <SMCLabel>{t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.LINE1')}</SMCLabel>
                
                <EmptyRow />

                {/* Server name */}
                <SMCTextInput
                    label={t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.SERVER_NAME')}
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                {/* SMS address */}
                <SMCTextInput
                    label={t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.SMS_ADDRESS')}
                    value={smsAddress}
                    onChange={e => setSmsAddress(e.target.value)}
                />
                {/* SMP server address */}
                <SMCTextInput
                    label={t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.SMP_SERVER_ADDRESS')}
                    value={smpServerAddress}
                    onChange={e => setSmpServerAddress(e.target.value)}
                />
                {/* SMP NAT address */}
                <SMCTextInput
                    label={t('SMP.SYSTEM.SMP_SERVERS.NEW_SERVER_WIZ.SMP_NAT_ADDRESS')}
                    value={smpNatAddress}
                    onChange={e => setSmpNatAddress(e.target.value)}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default ServerWizardBody;